export default "__VITE_ASSET__DKaKlCMZ__"